"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPpaLabelFromGql = void 0;
var _tsUtils = require("@ori/ts-utils");
var _isPpaLabel = require("./isPpaLabel");
const getPpaLabelFromGql = labels => labels?.find(label => (0, _tsUtils.isNonNullable)(label) && label.labelKey && (0, _isPpaLabel.isPpaLabel)(label.labelKey)) ?? null;
exports.getPpaLabelFromGql = getPpaLabelFromGql;
//# sourceMappingURL=getPpaLabelFromGql.js.map